import * as React from "react";
import {
  Image,
  View,
  Text,
  Alert,
  ScrollView,
  TouchableOpacity,
  StyleSheet,
} from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";
import { currentLanguage } from "../../../translations/CurrentLanguage";

import translation from "../../../translations/translation";
import LocalizedStrings from "react-native-localization";
import { colors, radius } from "../../../theme/modern";

let strings = new LocalizedStrings(translation);

export default class Sidebar extends React.Component {
  confirmLogout() {
    Alert.alert(
      strings.ConfirmLogout,
      strings.AreYouSureYouWantToLogout,
      [
        { text: strings.Cancel, style: "cancel" },
        {
          text: strings.Logout,
          onPress: () => this.props.onLogoutClick(),
        },
      ],
      { cancelable: false },
    );
  }

  onPress(route) {
    if (route === "Listing") {
      this.props.onListingClick();
    } else {
      this.props.navigation.navigate(route);
    }
  }

  renderAttendant() {
    const { attendant } = this.props;
    if (!attendant) {
      return null;
    }
    return (
      <View style={styles.attendant}>
        <View style={styles.avatar}>
          <Text style={styles.avatarText}>
            {attendant.user_name.charAt(0).toUpperCase()}
          </Text>
        </View>
        <View style={styles.attendantText}>
          <Text style={styles.attendantName} numberOfLines={1}>
            {attendant.user_name}
          </Text>
          <Text style={styles.attendantRole} numberOfLines={1}>
            {attendant.role}
          </Text>
        </View>
      </View>
    );
  }

  render() {
    strings.setLanguage(currentLanguage().companyLanguage);
    const routes = [
      { route: "Sales", caption: strings.Sales, icon: "shopping-cart" },
      { route: "Receipts", caption: strings.Receipts, icon: "file-text-o" },
      { route: "Listing", caption: strings.Listings, icon: "th-large" },
      { route: "Shift", caption: strings.Shift, icon: "clock-o" },
      {
        route: "ShiftReports",
        caption: strings.ShiftReports,
        icon: "bar-chart",
      },
      { route: "Settings", caption: strings.Settings, icon: "cog" },
    ];
    const active = this.props.activeItemKey;

    return (
      <View style={styles.container}>
        <View style={styles.brand}>
          <Image
            resizeMode="contain"
            style={styles.logo}
            source={{ uri: "whole_text_logo" }}
          />
        </View>
        {this.renderAttendant()}
        <ScrollView style={styles.menu}>
          {routes.map(item => {
            const selected = item.route === active;
            return (
              <TouchableOpacity
                key={item.route}
                activeOpacity={0.7}
                onPress={() => this.onPress(item.route)}
                style={[styles.item, selected ? styles.itemSelected : null]}
              >
                <View style={styles.itemIcon}>
                  <Icon
                    name={item.icon}
                    size={18}
                    color={selected ? colors.primary : colors.textMuted}
                  />
                </View>
                <Text
                  style={[
                    styles.itemText,
                    selected ? styles.itemTextSelected : null,
                  ]}
                >
                  {item.caption}
                </Text>
              </TouchableOpacity>
            );
          })}
        </ScrollView>
        <View style={styles.footer}>
          <TouchableOpacity
            activeOpacity={0.7}
            onPress={() => this.confirmLogout()}
            style={styles.item}
          >
            <View style={styles.itemIcon}>
              <Icon name="sign-out" size={18} color={colors.danger} />
            </View>
            <Text style={[styles.itemText, styles.logoutText]}>
              {strings.LogoutAttendant}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.surface,
  },
  brand: {
    height: 84,
    paddingHorizontal: 24,
    justifyContent: "center",
  },
  logo: {
    width: 176,
    height: 56,
  },
  attendant: {
    flexDirection: "row",
    alignItems: "center",
    marginHorizontal: 16,
    marginBottom: 12,
    padding: 12,
    borderRadius: radius.medium,
    backgroundColor: colors.background,
  },
  avatar: {
    width: 40,
    height: 40,
    borderRadius: 20,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.primary,
  },
  avatarText: {
    color: "#fff",
    fontSize: 16,
    fontWeight: "700",
  },
  attendantText: {
    flex: 1,
    marginLeft: 12,
  },
  attendantName: {
    fontSize: 15,
    fontWeight: "700",
    color: colors.text,
  },
  attendantRole: {
    marginTop: 1,
    fontSize: 13,
    color: colors.textMuted,
  },
  menu: {
    flex: 1,
    paddingHorizontal: 12,
  },
  item: {
    height: 46,
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 12,
    marginBottom: 2,
    borderRadius: radius.medium,
  },
  itemSelected: {
    backgroundColor: colors.primarySoft,
  },
  itemIcon: {
    width: 28,
    alignItems: "center",
  },
  itemText: {
    marginLeft: 10,
    fontSize: 15,
    fontWeight: "600",
    color: "#334155",
  },
  itemTextSelected: {
    color: colors.primary,
  },
  footer: {
    paddingHorizontal: 12,
    paddingVertical: 12,
    borderTopWidth: 1,
    borderTopColor: colors.border,
  },
  logoutText: {
    color: colors.danger,
  },
});
